import { render, staticRenderFns } from "./IncomeImportFromFileModal.vue?vue&type=template&id=ecc57ffa&scoped=true&"
import script from "./IncomeImportFromFileModal.vue?vue&type=script&lang=ts&"
export * from "./IncomeImportFromFileModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc57ffa",
  null
  
)

export default component.exports